import { upperFirst } from 'lodash';

export const capitalizeFirstChar = (text: string): string => {
  if (!text) return text;

  const lowerCased = text.toLowerCase();

  return upperFirst(lowerCased);
};
